import { useEffect, useState } from 'react';
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { Modal } from 'components/Modal';
import { CARD_TYPE_TEMPLATES } from 'constants/cardTypeMessageTemplates';
import { commonStrings, lineStrings } from 'constants/strings';
import { ECardTypeTemplateId } from 'types/cardTypeMessage';
import { CardTypeMessageTemplateThumbnail } from './CardTypeMessageTemplateThumbnail';

type Props = {
  open: boolean;
  selectedId: ECardTypeTemplateId;
  onClose: () => void;
  onApply: (templateId: ECardTypeTemplateId) => void;
};

const strings = lineStrings.management.cardTypeMessage;

export function CardTypeMessageTemplateModal({
  open,
  selectedId,
  onClose,
  onApply,
}: Props) {
  const [pendingId, setPendingId] = useState(selectedId);

  useEffect(() => {
    if (open) setPendingId(selectedId);
  }, [open, selectedId]);

  return (
    <Modal open={open} onClose={onClose} size="xl">
      <div className="flex max-h-[min(85vh,640px)] flex-col">
        <div className="flex shrink-0 items-start justify-between border-b border-neutral-200 pb-4">
          <h2 className="text-base font-bold text-neutral-900">
            {strings.templateModalTitle}
          </h2>
          <button
            type="button"
            className="rounded-lg p-1 text-neutral-500 hover:bg-neutral-100"
            aria-label={commonStrings.close}
            onClick={onClose}
          >
            <Icon icon="close" width={20} height={20} />
          </button>
        </div>

        <div className="grid min-h-0 flex-1 grid-cols-2 gap-6 overflow-y-auto py-6 px-1 sm:grid-cols-4">
          {CARD_TYPE_TEMPLATES.map((template) => (
            <CardTypeMessageTemplateThumbnail
              key={template.id}
              templateId={template.id}
              label={template.label}
              isSelected={pendingId === template.id}
              onClick={() => setPendingId(template.id)}
            />
          ))}
        </div>

        <div className="flex shrink-0 justify-end gap-2 border-t border-neutral-200 pt-4">
          <Button type="button" variant="outline" onClick={onClose}>
            {strings.templateModalCancel}
          </Button>
          <Button type="button" onClick={() => onApply(pendingId)}>
            {strings.templateModalApply}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
